import React from 'react';
import Link from 'next/link';
import styles from './ServerData.module.scss';
const ServerData = ({
  props
}) => {
  return <div className={styles['container']} data-sentry-component="ServerData" data-sentry-source-file="ServerData.tsx">
      <ul>
        <li>
          <Link href="/all-cottage" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">کلبه</Link>
        </li>
        <li>
          <Link href="/all-boomgardi" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">بومگردی</Link>
        </li>
        <li>
          <Link href="/search?pool=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">استخردار</Link>
        </li>
        <li>
          <Link href="/search?coastal=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">ساحلی</Link>
        </li>
        <li>
          <Link href="/search?forest=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">جنگلی</Link>
        </li>
        <li>
          <Link href="/search/city/%D8%AA%D9%87%D8%B1%D8%A7%D9%86?mid_term=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            رزرو بلند مدت
          </Link>
        </li>
        <li>
          <Link href="/search/city/%D8%AA%D9%87%D8%B1%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">تهران</Link>
        </li>
        <li>
          <Link href="/search/city/%DA%A9%D8%B1%D8%AF%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">کردان</Link>
        </li>
        <li>
          <Link href="/search/city/%D8%B1%D8%A7%D9%85%D8%B3%D8%B1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">رامسر</Link>
        </li>
        <li>
          <Link href="/search/city/%D9%82%D8%B4%D9%85" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">قشم</Link>
        </li>
        <li>
          <Link href="/search/city/%DA%A9%DB%8C%D8%B4" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">کیش</Link>
        </li>
        <li>
          <Link href="/search/city/%DA%86%D8%A7%D8%A8%D9%87%D8%A7%D8%B1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            چابهار
          </Link>
        </li>
        <li>
          <Link href="/search/city/%D9%85%D8%A7%D8%B3%D8%A7%D9%84" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">ماسال</Link>
        </li>
        <li>
          <Link href="/search/city/%D8%B1%D8%B4%D8%AA" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">رشت</Link>
        </li>
        <li>
          <Link href="/search/city/%D8%A8%D9%86%D8%AF%D8%B1%D8%A7%D9%86%D8%B2%D9%84%DB%8C" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            بندرانزلی
          </Link>
        </li>
        <li>
          <Link href="/search/city/%D8%AA%D8%A7%D9%84%D8%B4" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">تالش</Link>
        </li>
        <li>
          <Link href="/search/city/%D8%A7%D8%B5%D9%81%D9%87%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            اصفهان
          </Link>
        </li>
        <li>
          <Link href="/search/city/%D9%85%D8%B4%D9%87%D8%AF" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">مشهد</Link>
        </li>
        <li>
          <Link href="/search/city/%D9%85%D8%AD%D9%85%D9%88%D8%AF%20%D8%A2%D8%A8%D8%A7%D8%AF" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            محمود آباد
          </Link>
        </li>
        <li>
          <Link href="/search/city/%DA%86%D8%A7%D9%84%D9%88%D8%B3" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">چالوس</Link>
        </li>
        <li>
          <Link href="/search/city/%D8%B3%D9%88%D8%A7%D8%AF%20%DA%A9%D9%88%D9%87" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            سواد کوه
          </Link>
        </li>
        <li>
          <Link href="/search/city/%DA%A9%D8%B1%D8%AC" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">کرج</Link>
        </li>
        <li>
          <Link href="/search/city/%D9%81%D9%88%D9%85%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">فومن</Link>
        </li>
      </ul>
      <ul>
        <li>
          <Link href="/landing/app" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">دانلود</Link>
        </li>
        <li>
          <Link href="/" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">خانه</Link>
        </li>
        <li>
          <Link href="/search" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اقامتگاه‌ها</Link>
        </li>
        <li>
          <Link href="/bookmarks" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">علاقه‌مندی‌ها</Link>
        </li>
        <li>
          <Link href="/login" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">ورود|ثبت نام</Link>
        </li>
      </ul>
      <ul>
        <li>
          <h2>لحظه آخری‌ها</h2>
          <Link href="/search?late_night=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">مشاهده همه لحظه آخری‌ها </Link>
        </li>
        <li>
          <h2>ویلاهای شمال</h2>
          <Link href="/search?phrase=%D8%B4%D9%85%D8%A7%D9%84" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            مشاهده همه ویلاهای شمال
          </Link>
        </li>
        <li>
          <h2>ویلاهای اطراف تهران</h2>
          <Link href="/search?near_cities=%D8%AA%D9%87%D8%B1%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            مشاهده همه ویلاهای اطراف تهران
          </Link>
        </li>
        <li>
          <h2>اقامتگاه‌های تهران</h2>
          <Link href="/search/city/%D8%AA%D9%87%D8%B1%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            مشاهده همه اقامتگاه‌های تهران
          </Link>
        </li>
        <li>
          <h2>اقامتگاه‌های جنوب</h2>
          <Link href="/search?phrase=%D8%AC%D9%86%D9%88%D8%A8" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            مشاهده همه اقامتگاه‌های جنوب
          </Link>
        </li>
        <li>
          <h2>اقامتگاه‌های بوم‌گردی</h2>
          <Link href="/all-boomgardi" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">مشاهده همه اقامتگاه‌های بوم‌گردی </Link>
        </li>
      </ul>

      <Link target="_blank" rel="noreferrer" href="https://blog.shab.ir" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
        بیشتر از مجله شب بخوانید
      </Link>
      <ul>
        {props.blog.map((item, index) => <li key={'BLOGS_ITEM_' + index}>
            <Link href={item.link} rel="noreferrer" target="_blank">
              {item.title}
            </Link>
          </li>)}
      </ul>

      <ul>
        <li>
          <Link href="/support" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">تماس با ما</Link>
        </li>
        <li>
          <Link href="/about" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">درباره شب</Link>
        </li>
        <li>
          <Link target="_blank" rel="noreferrer" href="/faq" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            سوالات متداول
          </Link>
        </li>
        <li>
          <Link href="/terms" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">حقوق کاربران</Link>
        </li>
        <li>
          <Link href="/policies" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">قوانین استفاده از شب</Link>
        </li>
        <li>
          <Link href="/refund" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">قواعد باز پرداخت وجه</Link>
        </li>
        <li>
          <Link href="/landing/discount" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">کد تخفیف شب</Link>
        </li>
        <li>
          <Link target="_blank" rel="noreferrer" href="https://blog.shab.ir/?_ga=2.209945429.1525541813.1631430367-896746444.1625133755" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            وبلاگ شب
          </Link>
        </li>
        <li>
          <Link href="/help/trust" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">نحوه کار شب</Link>
        </li>
        <li>
          <Link href="/landing/b2b" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">همکاری سازمانی</Link>
        </li>
        <li>
          <Link href="/careers" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">فرصت های شغلی</Link>
        </li>
      </ul>
      <ul>
        <li>
          <Link target="_blank" rel="noreferrer" href="https://telegram.me/shab_ir" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            تلگرام
          </Link>
        </li>
        <li>
          <Link target="_blank" rel="noreferrer" href="https://twitter.com/shabhost" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            توئیتر
          </Link>
        </li>
        <li>
          <Link target="_blank" rel="noreferrer" href="https://www.instagram.com/_shab.ir/" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            اینستاگرام
          </Link>
        </li>
        <li>
          <Link target="_blank" rel="noreferrer" href="https://www.linkedin.com/company/shab.ir" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            لینکدین
          </Link>
        </li>
        <li>
          <Link target="_blank" rel="noreferrer" href="https://cafebazaar.ir/app/travel.shab" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            <img alt="cafebazaar" loading="lazy" width="56" height="33" decoding="async" data-nimg="1" src="/images/footer/bazar.png" />
          </Link>
        </li>
        <li>
          <Link target="_blank" rel="noreferrer" href="https://play.google.com/store/apps/details?id=travel.shab" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            <img alt="google play" loading="lazy" width="58" height="33" decoding="async" data-nimg="1" src="/images/footer/gplay.png" />
          </Link>
        </li>
        <li>
          <Link target="_blank" rel="noreferrer" href="https://sibapp.com/applications/Shab" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            <img alt="sib app" loading="lazy" width="80" height="40" decoding="async" data-nimg="1" src="/images/footer/sib.png" />
          </Link>
        </li>
        <li>
          <Link target="_blank" rel="noreferrer" href="https://anardoni.com/ios/app/travelshab" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
            <img alt="anardooni app" loading="lazy" width="81" height="24" decoding="async" data-nimg="1" src="/images/footer/anardooni.png" />
          </Link>
        </li>
      </ul>

      <div>
        <div>
          <h6>ویلاهای شمال</h6>
          <ul>
            <Link href="/search/city/%DA%86%D8%A7%D9%84%D9%88%D8%B3" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در چالوس
            </Link>
            <Link href="/search/city/%DA%A9%D9%84%D8%A7%D8%B1%D8%AF%D8%B4%D8%AA" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در کلاردشت
            </Link>
            <Link href="/search/city/%D8%AA%D8%A7%D9%84%D8%B4" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در تالش
            </Link>
            <Link href="/search/city/%D9%81%D9%88%D9%85%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در فومن
            </Link>
            <Link href="/search/city/%D8%A8%D8%A7%D8%A8%D9%84%D8%B3%D8%B1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در بابلسر
            </Link>
            <Link href="/search/city/%D9%85%D8%AD%D9%85%D9%88%D8%AF%20%D8%A2%D8%A8%D8%A7%D8%AF" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در محمود آباد
            </Link>
            <Link href="/search/city/%D9%81%D8%B1%DB%8C%D8%AF%D9%88%D9%86%20%DA%A9%D9%86%D8%A7%D8%B1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در فریدون کنار
            </Link>
            <Link href="/search/city/%D9%86%D9%88%D8%B4%D9%87%D8%B1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در نوشهر
            </Link>
            <Link href="/search/city/%D8%B1%D8%A7%D9%85%D8%B3%D8%B1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در رامسر
            </Link>
            <Link href="/search/city/%D9%85%D8%AA%D9%84%20%D9%82%D9%88%D8%B3%D9%84%D9%85%D8%A7%D9%86%20%D8%B4%D9%87%D8%B1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا متل قو
            </Link>
          </ul>
        </div>
        <div>
          <h6>ویلاهای جنوب</h6>
          <ul>
            <li>
              <Link href="/search/city/%D8%B4%DB%8C%D8%B1%D8%A7%D8%B2" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
                اجاره ویلا در شیراز
              </Link>
            </li>
            <li>
              <Link href="/search/city/%D8%A8%D9%86%D8%AF%D8%B1%D8%B9%D8%A8%D8%A7%D8%B3" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
                اجاره ویلا در بندرعباس
              </Link>
            </li>
            <li>
              <Link href="/search/province/%D9%87%D8%B1%D9%85%D8%B2%DA%AF%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
                اجاره ویلا در هرمزگان
              </Link>
            </li>
            <li>
              <Link href="/search/city/%D9%82%D8%B4%D9%85" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
                اجاره ویلا در قشم
              </Link>
            </li>
            <li>
              <Link href="/search/city/%DA%A9%DB%8C%D8%B4" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
                اجاره ویلا در کیش
              </Link>
            </li>
            <li>
              <Link href="/search/city/%D8%AC%D8%B2%DB%8C%D8%B1%D9%87%20%D9%87%D8%B1%D9%85%D8%B2" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
                اجاره ویلا در جزیره هرمز
              </Link>
            </li>
            <li>
              <Link href="/search/city/%DB%8C%D8%B2%D8%AF" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
                اجاره ویلا در یزد
              </Link>
            </li>
            <li>
              <Link href="/search/city/%D9%87%D9%85%D8%AF%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
                اجاره ویلا در همدان
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <h6>ویلاهای اطراف تهران</h6>
          <ul>
            <Link href="/search/city/%D8%AA%D9%87%D8%B1%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در تهران
            </Link>
            <Link href="/search/city/%D8%A8%D9%88%D9%85%D9%87%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در بومهن
            </Link>
            <Link href="/search/city/%D8%AF%D9%85%D8%A7%D9%88%D9%86%D8%AF" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در دماوند
            </Link>
            <Link href="/search/city/%D9%84%D9%88%D8%A7%D8%B3%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در لواسان
            </Link>
            <Link href="/search/city/%D8%B7%D8%A7%D9%84%D9%82%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در طالقان
            </Link>
            <Link href="/search/city/%DA%A9%D8%B1%D8%AF%D8%A7%D9%86" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در کردان
            </Link>
            <Link href="/search/city/%D9%81%DB%8C%D8%B1%D9%88%D8%B2%DA%A9%D9%88%D9%87" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا در فیروزکوه
            </Link>
          </ul>
        </div>
        <ul>
          <li>
            <Link href="/search?forest=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اجاره ویلا جنگلی</Link>
          </li>
          <li>
            <Link href="/search?coastal=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اجاره ویلا ساحلی</Link>
          </li>
          <li>
            <Link href="/search?pool=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اجاره ویلا استخردار</Link>
          </li>
          <li>
            <Link href="/search?indoor_pool=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره ویلا با استخر سرپوشیده
            </Link>
          </li>
          <li>
            <Link href="/search?outdoor_pool=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اجاره ویلا با استخر روباز</Link>
          </li>
          <li>
            <Link href="/search?in_town=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اجاره ویلا شهری</Link>
          </li>
          <li>
            <Link href="/search?mountain=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اجاره ویلا کوهستانی</Link>
          </li>
          <li>
            <Link href="/search?desert=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اجاره ویلا کویری</Link>
          </li>
          <li>
            <Link href="/all-cottage" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اجاره کلبه چوبی و جنگلی</Link>
          </li>
          <li>
            <Link href="/search?swiss-cottage=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">اجاره کلبه سوئیسی</Link>
          </li>
          <li>
            <Link href="/all-boomgardi" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">رزرو اقامتگاه بومگردی</Link>
          </li>
          <li>
            <Link href="/search/city/%D8%AA%D9%87%D8%B1%D8%A7%D9%86?apartment=1" data-sentry-element="Link" data-sentry-source-file="ServerData.tsx">
              اجاره خانه و آپارتمان مبله در تهران
            </Link>
          </li>
        </ul>
      </div>
    </div>;
};
export default ServerData;